import template from './forgot-password.html';
import { property } from 'lodash-es';
import { actions, selectors } from '../../state';
import './forgot-password.global.css';

const getPayloadMessage = property('payload.message');

class ForgotPasswordController {
  constructor(updStore, appShell) {
    'ngInject';
    Object.assign(this, { updStore, appShell });
  }

  $onInit() {
    this.disconnect = this.updStore.connect(mapStateToThis)(this);
  }

  $onDestroy() {
    this.disconnect();
  }

  submit(email) {
    const { dispatch } = this.updStore;

    const success = () => {
      this.appShell.interactors.session.actions.setForgotPassword(true);
      this.appShell.interactors.router.go('/sign-in');
    };

    const error = response => {
      dispatch(actions.message.error(`Sorry. ${getPayloadMessage(response)}`));
    };

    dispatch(actions.passwordReset.create({ email })).then(success, error);
  }
}

export const ForgotPasswordComponent = {
  template,
  controller: ForgotPasswordController,
};

function mapStateToThis(state) {
  return {
    submitting: selectors.pending.match(actions.passwordReset.isCreate, state),
  };
}
